export * from './all-mappings';
export * from './pwa-mappings';
export * from './domain';

// other-mappings is not exported, this is intentional. Idea is, that outside
// this lib, we should normally only need either pwa-mappings, or all-mappings,
// but I can't imagine a case where a list of non-pwa-mappings outside this lib
// would be useful.
